import { useState } from "react";
import { GICTransaction } from "../models/GICTransaction"
import { Button, DialogActions, DialogTitle } from "@mui/material";
import { TransactionType } from "../shared/Consts";
import { useDialog } from "../libs/dialog/DialogProvider";
import usePortfolio from "../hooks/PortfolioProvider";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";
import PortAccount from "../models/PortAccount";
import EvalText from "../components/EvalText";

export default function Redeem(props:{transactions:GICTransaction[],reinvest?:boolean}) {
    const {transactions} = props;
    const coupon = transactions.reduce((p,t) => t.coupon + p, 0)
    const [amount,setAmount] = useState<string>( coupon.toFixed(3) )
    const [error,setError] = useState<boolean>(false)
    const {closeDialog} = useDialog()
    const {setSnackbar} = useSnackbar()
    const {portfolio} = usePortfolio()
    const account = PortAccount.i

    const submit = async () => {
        const quantity = parseFloat(amount);
        if (quantity>0) {}
        else return setError(true)

        const trans = transactions[0]
        try {
            const div = trans as GICTransaction;
            div.price = 1;
            div.type = TransactionType.dividend;
            div.quantity = quantity;
            div.date = new Date()
            div.note += " Interest";
            div._id = ""
    
            await account.update(portfolio, div, !props.reinvest, 0)
    
            const redeem = trans as GICTransaction;
            redeem.price = 1;
            redeem.date = new Date();
            redeem._id = ""
            if (props.reinvest){
                redeem.type = TransactionType.reinvest;
                redeem.quantity = quantity;
                redeem.note += " Reinvest";
            }else{
                redeem.type = TransactionType.buy;
                redeem.quantity = -trans.principal;
                redeem.note += " Redeem"; 
            }
            await account.update(portfolio, redeem, !props.reinvest, 0);
            closeDialog()
        }catch(e){
            setSnackbar(e)
        }
    }
    const title = (props.reinvest ? "Reinvest" : "Redeem") + " " + transactions[0].holding.id
    return <>
        <DialogTitle>{title}</DialogTitle>
        <div className="content">
            <EvalText error={error} label="amount" variant="standard" value={amount} onEval={val=>setAmount(val)} onChange={e => setAmount(e.target.value)}/>
        </div>
        <DialogActions>
            <Button onClick={submit}>Submit</Button>
        </DialogActions>
    </>
}